import { p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
const row = React__default.memo(function Row(props) {
  let { id, SVs, children } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  let style = {};
  if (SVs.valign !== null) {
    style.verticalAlign = SVs.valign;
  }
  if (SVs.startBorder !== "none") {
    style.borderInlineStartStyle = "solid";
    if (SVs.startBorder === "minor") {
      style.borderInlineStartWidth = "thin";
    } else if (SVs.startBorder === "medium") {
      style.borderInlineStartWidth = "medium";
    } else {
      style.borderInlineStartWidth = "thick";
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { id, style, children });
});
export {
  row as default
};
